'use client';

export const areAllValuesFalsy = (obj) => Object.values(obj).every((value) => !value);

export const isPreview = () => !!window.is_preview; // TODO true is intended to hide BlockThisHost for ViewInvitation Preview... but is used many places and seems ok??
export const isMobile = () =>
  // TODO: Currently typhoon sets this in the mobile version of the common_base.html
  // ...however, Desktop ViewInvitation also uses this base, and is expecting this to be true.
  !!window.is_mobile_site;

export const getURLParameter = (name) => {
  // mocks
  const search = window.mock_location_search || window.location.search;
  const regex = new RegExp(`[?|&]${name}=([^&;]+?)(&|#|;|$)`);
  const matches = regex.exec(search) || [null, ''];
  const data = decodeURIComponent(matches[1].replace(/\+/g, '%20'));
  if (data) return data;
  return null;
};

const hrefFabric = (result) => {
  let templateType = result.usedAs;
  if (!templateType) {
    templateType = window.cards_page ? 'card' : 'invitation';
  }

  const urlPath = result.premium && templateType === 'card' ? 'cards' : 'invitation';
  return `/${urlPath}/${result.templateId}/create`;
};

export const buildHref = (result, tracking, currentPage) => {
  let href = hrefFabric(result);

  const params = new URLSearchParams();

  if (!result.premium && !window.cards_page) {
    // Free templates only
    params.append('template', result.templateId);
    params.append('event_type', window.category_name || result.eventType || '');
  } else if (result.premium) {
    // Premium invites & cards
    params.append('v', result.versionName || '');
  }

  if (window.gallery_query) {
    // Searches get keyword added as query param
    params.append('query', window.gallery_query);
  }

  params.append('c', window.category_name || result.eventType || '');

  const getPreviousParam = () => {
    let previous;

    if (window.is_favorites_page) {
      previous = 'favorites';
    } else if (params.get('query')) {
      previous = 'search';
    } else {
      previous = window.category_name || result.eventType || '';
    }

    return previous;
  };

  params.append('previous', getPreviousParam()); // for "back" buttons bc no time to refactor NavMachine in create/controller.js
  params.append('page', currentPage);

  const filterParams = tracking && tracking.split('&');
  if (filterParams) {
    filterParams.forEach((f) => {
      const pair = f.split('=');
      params.append(pair[0], pair[1]);
    });
  }

  if (result.pos >= 0) params.append('pos', result.pos);

  href += `?${params.toString()}`;
  return href;
};

export const formatHeaderTitle = (title) => {
  if (!title) return '';

  // todo handle this more elegantly
  // Removes dashes & capitalizes first letters
  const headerTitle = title.replace('-', ' ');

  const titleArray = headerTitle.split(' ');
  const splitString = titleArray.join(' ');
  const result = splitString.toString();
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const validUrlRegex =
  /^(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
export const validUrlInTextRegex =
  /(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?/gi;
export const isValidURL = (urlString) => validUrlRegex.test(urlString);
